import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../../common_components/Header';
import AdminHeader from '../../common_components/admin_module_header';
import Drawer from '../../common_components/Drawer';
import { lastSubmitAdd_action } from '../../actions/last_submit_action'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/withRouter';
import moment from 'moment';
import Modal from "react-modal";
import Loader from '../../utils/Loader'
import { getPaymentOrderDetails_action, insertHotelEnquiryDownload_action } from '../../actions/registration_action'
import { clearSessionStorage, countryActionId, toastError, toastSuccess, countryIWithCodeActionId, DOC_BASE_URL, link_BASE_URL } from '../../utils/constants'
import Pagination from '../../utils/pagination'
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { fill_action } from '../../actions/fillCombo_action'
import StepHeader from './stepHeader'
import Footer from '../../common_components/Footer';



class ThankYou extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            geturl: "",
            is_partner: false,
            exhibitionAdd: '',
            exhibitionName: '',
            ExhRegistrationNo: '',
            fromDate: '',
            toDate: '',
            amount: '',
            orderID: '',
            isClickValidation: false,
            scripts: [],
            isNavForm: false,
            SSRLink: ''
        }

        this.onHotelFormClick = this.onHotelFormClick.bind(this)
        this.backToLogin = this.backToLogin.bind(this)
        this.onPreviousClick = this.onPreviousClick.bind(this)
        this.getPaymentDetails = this.getPaymentDetails.bind(this)
        this.downloadFileHotelEnquiry = this.downloadFileHotelEnquiry.bind(this)
    }

    componentDidMount() {
    }

    getPaymentDetails() {
        this.setState({ isLoading: true })
        this.props
            .getPaymentOrderDetails_action(null, sessionStorage.getItem("sessionExhRegistrationID"), 'estimates')
            .then((data) => {
                this.setState({ isLoading: false })
                if (data.error != 1) {
                    // toastSuccess("Your space booking application has been submitted successfully.");
                    this.setState({
                        amount: data.data.amount,
                        orderID: data.data.cc_order_id
                    })
                }
                else {
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    componentWillUnmount() {
        const { isClickValidation, scripts, isNavForm } = this.state
        if (!isNavForm) {
            sessionStorage.clear()
            // if (!isClickValidation) {
            //     window.location.replace('http://localhost:3000/#/');
            // }

            if (scripts) {
                scripts.forEach((script) => {
                    if (script.parentNode) {
                        script.parentNode.removeChild(script);
                    }
                });
            }
        }
    }



    componentDidMount() {
        console.log('session : ', sessionStorage, this.props.location.state);
        window.history.pushState(null, "", window.location.href);
        window.onpopstate = function () {
            window.history.pushState(null, "", window.location.href);
        };
        if (sessionStorage.getItem('sessionExhibitionID') != null) {

            this.callGAScripts()
            var exhno = this.props.location.state != null && this.props.location.state != "" && this.props.location.state.ExhRegistrationNo != " " ? this.props.location.state.ExhRegistrationNo : ''
            // Exhibition From Date
            const dateString = sessionStorage.getItem('exhibitionDateFrom');
            const isFromDateValid = moment(dateString, "DD/MM/YYYY", true).isValid()
            const dateStringMoment = isFromDateValid ? moment.utc(dateString, "DD/MM/YYYY").format('DD MMMM YYYY') : moment.utc(dateString).format('DD MMMM YYYY')
            const dateObject = new Date(dateStringMoment);
            const fromDay = dateObject.getDate();
            const fromMonth = dateObject.toLocaleString('default', { month: 'long' });
            const fromYear = dateObject.getFullYear();
            const ExfromDate = `${fromDay} ${fromMonth} ${fromYear}`;
            console.log('dateString', dateString)
            console.log('dateStringMoment', dateStringMoment)
            console.log('dateObject', dateObject)

            // Exhibition to Date
            const dateString1 = sessionStorage.getItem('exhibitionDateTo');
            const isToDateValid = moment(dateString1, "DD/MM/YYYY", true).isValid()
            const dateString1Moment = isToDateValid ? moment.utc(dateString1, "DD/MM/YYYY").format('DD MMMM YYYY') : moment.utc(dateString1).format('DD MMMM YYYY')
            const dateObject1 = new Date(dateString1Moment);
            const toDay = dateObject1.getDate();
            const toMonth = dateObject1.toLocaleString('default', { month: 'long' });
            const toYear = dateObject1.getFullYear();
            const ExtoDate = `${toDay} ${toMonth} ${toYear}`;
            this.setState({
                geturl: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.geturl != " " ? this.props.location.state.geturl : '',
                exhibitionAdd: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.exhibitionAdd != " " ? this.props.location.state.exhibitionAdd : '',
                exhibitionName: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.exhibitionName != " " ? this.props.location.state.exhibitionName : '',
                ExhRegistrationNo: exhno,
                fromDate: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.fromDate != " " ? this.props.location.state.fromDate : (sessionStorage.getItem('exhibitionDateFrom') != null && sessionStorage.getItem('exhibitionDateFrom') != '') ? ExfromDate : '',
                toDate: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.toDate != " " ? this.props.location.state.toDate : (sessionStorage.getItem('exhibitionDateTo') != null && sessionStorage.getItem('exhibitionDateTo') != '') ? ExtoDate : '',
                SSRLink: sessionStorage.getItem('SSRLink')
            }, () => {
            })
            if (this.props.location.state != null && this.props.location.state != "") {
                this.setState({
                    is_partner: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.is_partner != "" && this.props.location.state.is_partner != undefined && this.props.location.state.is_partner != null ? this.props.location.state.is_partner : '',

                })
                sessionStorage.setItem('is_partner', this.props.location.state != null && this.props.location.state != "" && this.props.location.state.is_partner != "" && this.props.location.state.is_partner != undefined && this.props.location.state.is_partner != null ? this.props.location.state.is_partner : null)

                if (this.props.location.state.is_partner) {
                } else {
                    this.getPaymentDetails()
                }
            }
        }
    }

    async callGAScripts() {
        const { scripts } = this.state
        const script1 = document.createElement("script");
        script1.async = true;
        script1.src = "https://www.googletagmanager.com/gtag/js?id=G-1QY8MXN64V";
        document.head.appendChild(script1);
        scripts.push(script1); // Store reference

        const script2 = document.createElement("script");
        script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-1QY8MXN64V');
    `;
        document.head.appendChild(script2);
        scripts.push(script2)
    }

    onPreviousClick(e) {
        const { isClickValidation } = this.state
        e.preventDefault();
        var url = sessionStorage.getItem('sessionExhMailWebsite')
        this.setState({ isClickValidation: true }, () => {
            sessionStorage.clear()
            const win = window.location.replace(url)
            // const win = window.open(this.state.geturl, '_blank');
            if (win != null) {
                win.focus();
            }
        })
    }

    backToLogin(e) {
        const { isClickValidation } = this.state
        e.preventDefault();
        // var url = sessionStorage.getItem('sessionExhMailWebsite')
        this.setState({ isClickValidation: true }, () => {
            const win = window.location.replace(`${link_BASE_URL}`)
            setTimeout(() => {
                sessionStorage.clear()
                // const win = window.open(this.state.geturl, '_blank');
                if (win != null) {
                    win.focus();
                }
            }, 500);
        })
    }

    onHotelFormClick(e) {
        e.preventDefault();
        this.setState({
            isNavForm: true
        }, () => {
            this.props.navigate("/hotelEnquiryForm", {
                state: { from: "thanks", exhID: sessionStorage.getItem('sessionExhRegistrationID') },
            });
        })
    }

    downloadFileHotelEnquiry = () => {
        this.setState({ isLoading: true })
        // const url = `https://india-itme.com/document/Exhibition/HotelEnquiryForm/3/Hotel-Enquiry-Form.pdf`; // Replace with your file URL
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", "Hotel-Enquiry-Form.pdf"); // Set the file name
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        setTimeout(() => {
            console.log("pppp")
            this.props
                .insertHotelEnquiryDownload_action(sessionStorage.getItem("sessionExhRegistrationID"))
                .then((data) => {
                    this.setState({ isLoading: false })
                    if (data.error != 1) {
                        // toastSuccess("Your space booking application has been submitted successfully.");
                    }
                    else {
                        toastError(data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }, 500);
    };

    render() {
        const { isLoading, geturl, SSRLink, is_partner, exhibitionAdd, fromDate, toDate, exhibitionName, ExhRegistrationNo } = this.state
        console.log(sessionStorage.getItem('SSRLink'))
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (null)}
                <ToastContainer />
                {/* <!-- PAGE --> */}
                {/* <Header /> */}
                {!sessionStorage.getItem('sessionExhibitionID') ? (<AdminHeader isSteper={false} />) : (<Header />)}
                {/* <!-- CONTAINER --> */}
                <div >
                    {/* <StepHeader /> */}

                    {/* <!-- ROW-1 --> {geturl}*/}
                    <div
                        className="main-content app-content mt-0"
                        style={{ backgroundColor: "#ececec", height: '100vh' }}
                    >
                        <div className="side-app">
                            {!sessionStorage.getItem('sessionExhibitionID') ? (
                                <div style={{ marginTop: "100px" }}>
                                    <strong style={{ fontSize: "23px" }}>Your Form Already Submitted Successfully</strong>

                                </div>
                            ) :
                                (<div className="main-container container-fluid top-form-name">
                                    <div className="row ">
                                        <form className="needs-validation " noValidate="">
                                            <div className="form-row mt-4">
                                                <div className="form-group col-md-7 p-4 thank-box">
                                                    {is_partner == true ? <div className="form-group mb-2">
                                                        <h4
                                                            className="mb-0 pt-2 pb-4 thank-top-mes text-aqua"
                                                        >
                                                            <strong>Application Submitted Successfully</strong>
                                                        </h4>
                                                        <p className="mb-1 mt-1 text-center com-font">
                                                            Thank you for submitting your partner application for
                                                        </p>
                                                        <p className="mt-1 mb-0 text-center com-font">
                                                            { }
                                                            {exhibitionName} from {fromDate} to {toDate}
                                                        </p>
                                                        <p className="mb-3 text-center com-font">
                                                            {exhibitionAdd}
                                                        </p>
                                                        <h5 className="mb-4 pt-1" style={{ fontWeight: "bold" }}>
                                                            <strong className='fw-semibold'>Your Application Number is
                                                                <span> {ExhRegistrationNo}</span></strong>
                                                        </h5>
                                                        <p className="mb-0 mt-2 text-center com-font">
                                                            <strong>Note:</strong> Kindly check your registered email
                                                            address for acknowledgement of application.
                                                            {/* and 1st <br></br> Proforma
                                                        for space booking amount. */}
                                                        </p>
                                                    </div> :
                                                        <div className="form-group mb-2">
                                                            <h4
                                                                className="mb-0 pt-2 pb-4 thank-top-mes"
                                                                style={{ color: "#318958" }}
                                                            >
                                                                <strong>Application Submitted Successfully</strong>
                                                            </h4>
                                                            <p className="mb-1 mt-1 text-center com-font">
                                                                Thank you for submitting your space booking application for
                                                            </p>
                                                            <p className="mt-1 mb-0 text-center com-font">
                                                                {sessionStorage.getItem("sessionExhibitionName")} from {fromDate} to {toDate}
                                                            </p>
                                                            <p className="mb-3 text-center com-font">
                                                                at {sessionStorage.getItem("exhibitionAddress")}
                                                            </p>
                                                            <h5 className="mb-4 pt-1" style={{ fontWeight: "bold" }}>
                                                                <strong>Your Application Number is
                                                                    <span> {sessionStorage.getItem("sessionExhRegistrationNo")}</span></strong>
                                                            </h5>
                                                            {sessionStorage.getItem('agentCode') != null && sessionStorage.getItem('agentCode') != undefined && sessionStorage.getItem("paidByExh") != 'true' ? <p className="mb-0 mt-2 text-center com-font">
                                                                <strong>Note:</strong>  For further assistance please contact your country specific Space Selling Representative mentioned on below link.
                                                            </p> : <p className="mb-0 mt-2 text-center com-font">
                                                                <strong>Note:</strong> Kindly check your registered email
                                                                address for acknowledgement of application and 1st <br></br> Proforma
                                                                for space booking amount.
                                                            </p>}

                                                            {sessionStorage.getItem('agentCode') != null && sessionStorage.getItem('agentCode') != undefined && sessionStorage.getItem("paidByExh") != 'true' && <p style={{ marginTop: '5px', textAlign: 'center' }}>
                                                                <a href={SSRLink} target='blank' className='text-primary' >Click here to see Space Selling Representative</a>
                                                            </p>
                                                            }
                                                            {this.state.orderID != '' && this.state.amount != '' && <p className="mb-0 mt-2 text-center com-font">
                                                                Your payment has been successfully processed. Order number: <strong>{this.state.orderID}</strong> and Paid Amount: <strong>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.amount}</strong>
                                                            </p>}

                                                        </div>}
                                                    <div classname="" style={{ display: 'flex', justifyContent: 'center', alignItems: 'end' }}>
                                                        <div classname="mt-1 mb-4">

                                                            <button type="button" class="btn btn-aqua" onClick={e => this.onPreviousClick(e)}>BACK TO EVENT WEBSITE</button>

                                                        </div>
                                                        {sessionStorage.getItem('agentCode') != null && sessionStorage.getItem('agentCode') != undefined && sessionStorage.getItem("paidByExh") != 'true' ? <></> : <div classname="mt-1 mb-4">

                                                            <button type="button" class="btn btn-aqua mx-3" onClick={e => this.backToLogin(e)}>BACK TO LOGIN</button>

                                                        </div>}
                                                        <div classname="mt-3 mb-4">

                                                            <button type="button" class="btn btn-aqua" onClick={e => this.onHotelFormClick(e)}>HOTEL ENQUIRY  FORM</button>


                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>)}
                        </div>
                    </div>


                </div>
                <Footer />
                {/* <!-- CONTAINER END --> */}

            </>
        );
    }
}

export default withRouter(connect(null, {
    lastSubmitAdd_action, getPaymentOrderDetails_action, insertHotelEnquiryDownload_action
})(ThankYou));

